interface DrinkWindowBadgeProps {
  drinkFrom?: string | null;
  drinkBy?: string | null;
}

type Status = 'drink-now' | 'too-early' | 'past-peak' | 'no-window';

function getStatus(drinkFrom?: string | null, drinkBy?: string | null): Status {
  if (!drinkFrom && !drinkBy) return 'no-window';
  const now = new Date();
  const from = drinkFrom ? new Date(drinkFrom) : null;
  const by = drinkBy ? new Date(drinkBy) : null;
  if (by && now > by) return 'past-peak';
  if (from && now < from) return 'too-early';
  return 'drink-now';
}

const LABELS: Record<Status, string> = {
  'drink-now': 'Drink now',
  'too-early': 'Hold',
  'past-peak': 'Past peak',
  'no-window': '',
};

export default function DrinkWindowBadge({ drinkFrom, drinkBy }: DrinkWindowBadgeProps) {
  const status = getStatus(drinkFrom, drinkBy);
  if (status === 'no-window') return null;

  return (
    <span className={`drink-badge drink-badge-${status}`}>
      {LABELS[status]}
    </span>
  );
}
